import { SidebarFooter, SidebarMenu, SidebarMenuItem } from '@/components/ui/sidebar'
import type { PropsWithChildren } from 'react'
import { LayoutUserDropdown, type LayoutUserDropdownProps } from '@/components/layout/LayoutUserDropdown'

export interface LayoutSidebarFooterProps extends LayoutUserDropdownProps {}

export const LayoutSidebarFooter = ({
  children,
  ...userDropdown
}: PropsWithChildren<LayoutSidebarFooterProps>) => {
  return (
    <SidebarFooter>
      <SidebarMenu>
        <SidebarMenuItem>
          <LayoutUserDropdown {...userDropdown}>{children}</LayoutUserDropdown>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarFooter>
  )
}
